@if (!isSearch) {
  <div class="faq-section">
    @if (faqArea$ | async; as faq) {
      <h3>{{ faq.title }}</h3>
      <h4>{{ 'faq-section.' + faq.target | i18next }}</h4>
      <h4 class="regular">{{ faq.subtitle }}</h4>
      @for (section of faq.faqSections; track section.id) {
        <a
          class="faq-section__body"
          [routerLink]="section | slug">
          <h4>
            {{ section.title }}&nbsp;<sharry-icon
              registryName="caret-right"
              svgClass="svg-icon caret"></sharry-icon>
          </h4>
          <p
            class="internal-link"
            [innerHTML]="section.subtitle"></p>
        </a>
      }
    } @else {
      <sharry-loading [fullscreen]="true"></sharry-loading>
    }
  </div>
}
